import classNames from 'classnames';
import type { FC } from 'react';
import type { InputHTMLAttributesWithCompletionEvent } from './type';

export const RenameInput: FC<InputHTMLAttributesWithCompletionEvent> = (
  props,
) => {
  // props
  const { className, onComplete, ...attrs } = props;
  return (
    <input
      {...attrs}
      autoFocus
      type="text"
      className={classNames(
        'w-full p-1 bg-transparent rounded transition disabled:text-secondary-2',
        className,
      )}
      ref={(ref) => {
        if (ref && typeof onComplete === 'function') {
          ref.onchange = (e) =>
            onComplete((e.target as HTMLInputElement).value);
        }
      }}
    />
  );
};
